// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AccidentHistoryForm .h4,
.AccidentHistoryForm label,
.AccidentHistoryForm .AccidentHistoryFormHeader,
.AccidentHistoryForm .AccidentHistoryFormHistoryTitle {
  color: var(--bs-primary);
}
.AccidentHistoryForm .AccidentHistoryFormHeader {
  padding-bottom: 1rem;
}
.AccidentHistoryForm .AccidentHistoryFormHeader > .col {
  display: flex;
  flex-direction: column;
}
.AccidentHistoryForm .AccidentHistoryFormHeader > .col .AccidentHistoryFormTitle {
  padding: 0.25rem 0 1rem 0;
  border-bottom: 1px solid #ccc;
  text-transform: uppercase;
}
.AccidentHistoryForm .AccidentHistoryFormSectionHeader {
  padding-bottom: 1rem;
}
.AccidentHistoryForm .AccidentHistoryFormSectionHeader .AccidentHistoryFormCommentsTitle {
  padding: 0.5rem 0 1rem 0;
  border-bottom: 1px solid #ccc;
  text-transform: uppercase;
}
.AccidentHistoryForm .AccidentHistoryFormLinkTrips {
  padding-bottom: 0.5rem;
}
.AccidentHistoryForm .AccidentHistoryFormLinkTrips > .col {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.AccidentHistoryForm .AccidentHistoryFormUpload {
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
}
.AccidentHistoryForm .AccidentHistoryFormHistory {
  padding-bottom: 1rem;
}
.AccidentHistoryForm .AccidentHistoryFormHistory .AccidentHistoryFormHistoryTitle {
  padding: 0.25rem 0 1rem 0;
  border-bottom: 1px solid #ccc;
  text-transform: uppercase;
}
.AccidentHistoryForm .AccidentHistoryFormCheckboxHeader {
  padding-top: 0.75rem;
}
.AccidentHistoryForm .TextArea[name=description] {
  height: 7rem !important;
  resize: none !important;
}
.AccidentHistoryForm .TextArea[name=thirdPartyInformation],
.AccidentHistoryForm .TextArea[name=damageToOtherVehicles],
.AccidentHistoryForm .TextArea[name=typeOfMedicalAttention],
.AccidentHistoryForm .TextArea[name=infoOfInjuredParties],
.AccidentHistoryForm .TextArea[name=infoOfCrewMembers] {
  height: 5rem !important;
  resize: none !important;
}
.AccidentHistoryForm .btn {
  text-transform: uppercase;
}
.AccidentHistoryForm .btn[type=SUBMIT] {
  width: 100%;
  margin: 2rem 0;
}
.AccidentHistoryForm .SimpleTable-Controls {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/features/AccidentHistory/components/AccidentHistoryForm/styles.scss"],"names":[],"mappings":"AACE;;;;EAIE,wBAAA;AAAJ;AAEE;EACE,oBAAA;AAAJ;AACI;EACE,aAAA;EACA,sBAAA;AACN;AAAM;EACE,yBAAA;EACA,6BAAA;EACA,yBAAA;AAER;AAEE;EACE,oBAAA;AAAJ;AACI;EACE,wBAAA;EACA,6BAAA;EACA,yBAAA;AACN;AAEE;EACE,sBAAA;AAAJ;AACI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AACN;AAEE;EACE,mBAAA;EACA,sBAAA;AAAJ;AAEE;EACE,oBAAA;AAAJ;AACI;EACE,yBAAA;EACA,6BAAA;EACA,yBAAA;AACN;AAEE;EACE,oBAAA;AAAJ;AAEE;EACE,uBAAA;EACA,uBAAA;AAAJ;AAEE;;;;;EAKE,uBAAA;EACA,uBAAA;AAAJ;AAEE;EACE,yBAAA;AAAJ;AACI;EACE,WAAA;EACA,cAAA;AACN;AAEE;EACE,wBAAA;AAAJ","sourcesContent":[".AccidentHistoryForm {\n  .h4,\n  label,\n  .AccidentHistoryFormHeader,\n  .AccidentHistoryFormHistoryTitle {\n    color: var(--bs-primary);\n  }\n  .AccidentHistoryFormHeader {\n    padding-bottom: 1rem;\n    > .col {\n      display: flex;\n      flex-direction: column;\n      .AccidentHistoryFormTitle {\n        padding: 0.25rem 0 1rem 0;\n        border-bottom: 1px solid #ccc;\n        text-transform: uppercase;\n      }\n    }\n  }\n  .AccidentHistoryFormSectionHeader {\n    padding-bottom: 1rem;\n    .AccidentHistoryFormCommentsTitle {\n      padding: 0.5rem 0 1rem 0;\n      border-bottom: 1px solid #ccc;\n      text-transform: uppercase;\n    }\n  }\n  .AccidentHistoryFormLinkTrips {\n    padding-bottom: 0.5rem;\n    > .col {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n    }\n  }\n  .AccidentHistoryFormUpload {\n    padding-top: 0.6rem;\n    padding-bottom: 0.6rem;\n  }\n  .AccidentHistoryFormHistory {\n    padding-bottom: 1rem;\n    .AccidentHistoryFormHistoryTitle {\n      padding: 0.25rem 0 1rem 0;\n      border-bottom: 1px solid #ccc;\n      text-transform: uppercase;\n    }\n  }\n  .AccidentHistoryFormCheckboxHeader {\n    padding-top: 0.75rem;\n  }\n  .TextArea[name='description'] {\n    height: 7rem !important;\n    resize: none !important;\n  }\n  .TextArea[name='thirdPartyInformation'],\n  .TextArea[name='damageToOtherVehicles'],\n  .TextArea[name='typeOfMedicalAttention'],\n  .TextArea[name='infoOfInjuredParties'],\n  .TextArea[name='infoOfCrewMembers'] {\n    height: 5rem !important;\n    resize: none !important;\n  }\n  .btn {\n    text-transform: uppercase;\n    &[type='SUBMIT'] {\n      width: 100%;\n      margin: 2rem 0;\n    }\n  }\n  .SimpleTable-Controls {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
